import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Navigation.css';
import logoImage from '../assets/logo/logo.png';

const Navigation = () => {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [logoLoaded, setLogoLoaded] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const logoRef = useRef(null);

  const handleMouseEnter = (menu) => {
    setActiveDropdown(menu);
  };

  const handleMouseLeave = () => {
    setActiveDropdown(null);
  };

  const handleMobileMenuToggle = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleMobileMenuClose = () => {
    setIsMobileMenuOpen(false);
    setActiveDropdown(null);
  };

  const handleMobileDropdownToggle = (menu) => {
    setActiveDropdown(activeDropdown === menu ? null : menu);
  };

  useEffect(() => {
    // Logo yüklendiğinde kontrol et
    if (logoRef.current) {
      if (logoRef.current.complete && logoRef.current.naturalHeight !== 0) {
        setLogoLoaded(true);
      }
    }
  }, []);

  useEffect(() => {
    // Mobil menü açıkken dışarı tıklandığında kapat
    const handleClickOutside = (event) => {
      if (isMobileMenuOpen && window.innerWidth <= 768) {
        const nav = document.querySelector('.main-navigation');
        if (nav && !nav.contains(event.target)) {
          setIsMobileMenuOpen(false);
          setActiveDropdown(null);
        }
      }
    };

    if (isMobileMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      // Menü açıkken body scroll'unu engelle
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = '';
    };
  }, [isMobileMenuOpen]);

  const corporateMenu = [
    { name: 'About Us', link: '/about' },
    { name: 'Quality Policy', link: '/quality-policy' },
    { name: 'Our Mission', link: '/our-mission' },
    { name: 'Our Vision', link: '/our-vision' }
  ];

  const systemCertMenu = [
    { name: 'ISO 9001 Quality Management System', link: '/iso-9001' },
    { name: 'ISO 14001 Environmental Management System', link: '/iso-14001' },
    { name: 'ISO 45001 Occupational Health and Safety Management System', link: '/iso-45001' },
    { name: 'ISO 22000 Food Safety Management System', link: '/iso-22000' },
    { name: 'ISO 13485 Quality Management System for Medical Devices', link: '/iso-13485' },
    { name: 'ISO 27001 Information Security Management System', link: '/iso-27001' },
    { name: 'ISO 20000-1 Information Technology Service Management System', link: '/iso-20000' },
    { name: 'ISO 27701 Personal Data Management System', link: '/iso-27701' },
    { name: 'ISO 16949 Automotive Quality Management System', link: '/iso-16949' },
    { name: 'ISO 50001 Energy Management System', link: '/iso-50001' },
    { name: 'ISO 22301 Societal Security and Business Continuity Management System', link: '/iso-22301' },
    { name: 'Fight Against Corruption with ISO 37001 Corruption Management System', link: '/iso-37001' },
    { name: 'ISO 10002 Customer Satisfaction Management System', link: '/iso-10002' },
    { name: 'ISO 28001 Supply Chain Security Management System', link: '/iso-28001' },
    { name: 'ISO 22483 Tourism Quality Management System', link: '/iso-22483' },
    { name: 'ISO 14064 Carbon Footprint Verification', link: '/iso-14064' },
    { name: 'ISO 14046 Water Footprint Verification', link: '/iso-14046' },
    { name: 'ISO 31000 Enterprise Risk Management System', link: '/iso-31000' },
    { name: 'ISO 39001:2012 Road Traffic Safety Management System', link: '/iso-39001' }
  ];

  const productCertMenu = [
    { name: 'CE Certification', link: '/ce-certification' },
    { name: 'BRC Certificate', link: '/brc-certificate' },
    { name: 'Kosher Certificate', link: '/kosher-certificate' },
    { name: 'FSSC 22000 Certificate', link: '/fssc-22000' }
  ];

  const qualityCertMenu = [
    { name: 'ROHS Certificate', link: '/rohs-certificate' },
    { name: 'AS 9100 Certificate', link: '/as-9100' },
    { name: 'GHP Certificate (Good Hygiene Practices)', link: '/ghp-certificate' },
    { name: 'GMP Certificate (Good Manufacturing Practices)', link: '/gmp-certificate' },
    { name: 'WRAS Certificate', link: '/wras-certificate' }
  ];

  return (
    <nav className="main-navigation">
      <div className="nav-container">
        <div className="logo-section">
          <Link to="/">
            <img 
              ref={logoRef}
              src={logoImage} 
              alt="NQC Logo" 
              className="logo-image"
              onLoad={() => {
                setLogoLoaded(true);
              }}
              onError={(e) => {
                // PNG yoksa SVG dene
                if (e.target.src.includes('.png')) {
                  e.target.src = '/assets/logo/logo.svg';
                  return;
                }
                // SVG de yoksa JPG dene
                if (e.target.src.includes('.svg')) {
                  e.target.src = '/assets/logo/logo.jpg';
                  return;
                }
                // JPG de yoksa JPEG dene
                if (e.target.src.includes('.jpg')) {
                  e.target.src = '/assets/logo/logo.jpeg';
                  return;
                }
                // Hiçbiri yoksa görseli gizle
                e.target.style.display = 'none';
                setLogoLoaded(false);
              }}
            />
          </Link>
          <div className="logo-text">
            <h1>NQC</h1>
            <p>TESTING AND CONFORMITY ASSESSMENT CERTIFICATION</p>
          </div>
        </div>
        
        <button 
          className="mobile-menu-toggle"
          onClick={handleMobileMenuToggle}
          aria-label="Toggle menu"
        >
          <span className={isMobileMenuOpen ? 'hamburger open' : 'hamburger'}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
        
        <ul className={`nav-menu ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
          <li 
            className="nav-item"
            onMouseEnter={() => handleMouseEnter('corporate')}
            onMouseLeave={handleMouseLeave}
          >
            <a 
              href="#corporate"
              onClick={(e) => {
                if (window.innerWidth <= 768) {
                  e.preventDefault();
                  handleMobileDropdownToggle('corporate');
                }
              }}
            >
              Corporate <span className="dropdown-arrow">▼</span>
            </a>
            {activeDropdown === 'corporate' && (
              <ul className="dropdown-menu">
                {corporateMenu.map((item, index) => (
                  <li key={index}>
                    <Link to={item.link} onClick={handleMobileMenuClose}>{item.name}</Link>
                  </li>
                ))}
              </ul>
            )}
          </li>
          <li 
            className="nav-item"
            onMouseEnter={() => handleMouseEnter('system')}
            onMouseLeave={handleMouseLeave}
          >
            <a 
              href="#system"
              onClick={(e) => {
                if (window.innerWidth <= 768) {
                  e.preventDefault();
                  handleMobileDropdownToggle('system');
                }
              }}
            >
              System Certification <span className="dropdown-arrow">▼</span>
            </a>
            {activeDropdown === 'system' && (
              <ul className="dropdown-menu">
                {systemCertMenu.map((item, index) => (
                  <li key={index}>
                    <Link to={item.link} onClick={handleMobileMenuClose}>{item.name}</Link>
                  </li>
                ))}
              </ul>
            )}
          </li>
          <li 
            className="nav-item"
            onMouseEnter={() => handleMouseEnter('product')}
            onMouseLeave={handleMouseLeave}
          >
            <a 
              href="#product"
              onClick={(e) => {
                if (window.innerWidth <= 768) {
                  e.preventDefault();
                  handleMobileDropdownToggle('product');
                }
              }}
            >
              Product Certification <span className="dropdown-arrow">▼</span>
            </a>
            {activeDropdown === 'product' && (
              <ul className="dropdown-menu">
                {productCertMenu.map((item, index) => (
                  <li key={index}>
                    <Link to={item.link} onClick={handleMobileMenuClose}>{item.name}</Link>
                  </li>
                ))}
              </ul>
            )}
          </li>
          <li 
            className="nav-item"
            onMouseEnter={() => handleMouseEnter('quality')}
            onMouseLeave={handleMouseLeave}
          >
            <a 
              href="#quality"
              onClick={(e) => {
                if (window.innerWidth <= 768) {
                  e.preventDefault();
                  handleMobileDropdownToggle('quality');
                }
              }}
            >
              Quality Certification <span className="dropdown-arrow">▼</span>
            </a>
            {activeDropdown === 'quality' && (
              <ul className="dropdown-menu">
                {qualityCertMenu.map((item, index) => (
                  <li key={index}>
                    <Link to={item.link} onClick={handleMobileMenuClose}>{item.name}</Link>
                  </li>
                ))}
              </ul>
            )}
          </li>
          <li>
            <Link to="/contact" onClick={handleMobileMenuClose}>Contact</Link>
          </li>
        </ul>
        
        <Link 
          to="/certificate-query" 
          className="certificate-query-btn"
          onClick={handleMobileMenuClose}
        >
          Certificate Query
        </Link>
      </div>
    </nav>
  );
};

export default Navigation;

